import { ActivityStore } from "../store/activity/ActivityStore";

export const useIsTradeHistoryReturned = () => {
  const { isLoading, data } = ActivityStore.useState(s => s.history);
  return !isLoading && data !== undefined;
};
